import React, {FC, useEffect} from 'react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import {useStoreon} from 'storeon/react';
import { Events, State } from '@/interfaces';
import { ICertificateGenerator } from '@/types';
import styles from '../../styles/index.module.scss';
import {CERTIFICATES_TYPE, SIDEBAR_TYPES} from '../../const';
import {ClockIcon, MinusIcon, PlusIcon} from '../../../../../../assets';


interface ICertificateComponent  {
    activeSideBarItem: number;
    clickItem: (deposit: Record<string, any>)=>void;
    activeItem: Record<string, any> | null;
    setCount:(e: number)=>void;
    count:number
}

const CertificateComponent:FC<ICertificateComponent> = ({activeSideBarItem,clickItem,activeItem,count,setCount}) => {
    const { dispatch, arrCertificatesGenerator } = useStoreon<State, Events>('arrCertificatesGenerator');
    const list = arrCertificatesGenerator.filter((item)=>item.side === CERTIFICATES_TYPE[activeSideBarItem].id);

    const getCertificateValueFormatted = (certificate: ICertificateGenerator) => {
        if (certificate.rent_pay_count > 0) {
            return `${certificate.rent_pay_count} ар.`
        }

        return `${certificate.wave_sets} сет.`
    }

    const cn = cnBind.bind(styles);
    useEffect(()=>{
        dispatch('certificatesGenerate/get', {});
    },[])

    return (
        <div className={cn({
            list: list.length !== 0,
            'list--missing': list.length === 0
        })}>
            {list.length === 0 ?
                <div>
                    Сертификаты отсутсвуют...
                </div>
                :
                <>
                    {list.map((certificate) => {
                        return (
                            <div
                                key={certificate.id}
                                onClick={()=>clickItem(certificate)}
                                role='button'
                                tabIndex={0}
                                className={cn({
                                    'list__item': true,
                                    'list__item--active': activeItem?.id === certificate.id
                                })}
                            >

                                        <p className={styles['list__item--title']}>{certificate.title }</p>
                                        <div className={styles['list__item_time']}>
                                            <GxIcon src={ClockIcon} className={styles['list__item_time--icon']}/>
                                            {activeSideBarItem === SIDEBAR_TYPES.HYBRID &&  <span className={styles['list__item_time--text']}>
                                                { `${certificate.fly_minutes} мин. /${certificate.wave_sets} сет(ов)`}
                                            </span>}
                                            {activeSideBarItem === SIDEBAR_TYPES.PIPE &&  <span className={styles['list__item_time--text']}>
                                                { `${certificate.fly_minutes} мин.`}
                                            </span>}
                                            {activeSideBarItem === SIDEBAR_TYPES.WAVE &&  <span className={styles['list__item_time--text']}>
                                                { getCertificateValueFormatted(certificate) }
                                            </span>}
                                        </div>
                                <div className={styles['list__item_info']}>
                                    <span className={styles['list__item_info--price']}>{Number(certificate.price).toLocaleString()}</span>
                                     {activeItem?.id === certificate.id &&
                                        <div className={styles['count']}>
                                          <button type='button' className={styles['count--btn']} disabled={count === 1} onClick={()=>setCount(count - 1)}>
                                            <GxIcon src={MinusIcon} className={styles['count--icon']}/>
                                          </button>
                                          <span className={styles['count--text']}>{count}</span>
                                          <button  type='button' className={styles['count--btn']} onClick={()=>setCount(count + 1)}>
                                            <GxIcon src={PlusIcon} className={styles['count--icon']}/>
                                          </button>
                                        </div>
                                     }
                                </div>
                            </div>
                        )
                    })}
                </>
            }
        </div>
    );
};
export default CertificateComponent;